"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCENE_OPTIONS = void 0;
exports.createDefaultEditorConfig = createDefaultEditorConfig;
exports.createDefaultTemplate = createDefaultTemplate;
exports.deleteTemplate = deleteTemplate;
exports.getTemplateById = getTemplateById;
exports.getTemplates = getTemplates;
exports.mapApiToEditor = mapApiToEditor;
exports.mapEditorToApi = mapEditorToApi;
exports.maskAddress = maskAddress;
exports.maskPhone = maskPhone;
exports.mockReceiptData = void 0;
exports.saveTemplate = saveTemplate;
exports.saveTemplates = saveTemplates;
var STORAGE_KEY = 'rs_receipt_templates';
var SCENE_OPTIONS = exports.SCENE_OPTIONS = [{
  label: '外卖',
  value: 1
}, {
  label: '自提',
  value: 2
}, {
  label: '酒店',
  value: 3
}, {
  label: '团购',
  value: 4
}];
function toBool(value) {
  return Number(value) === 1 || value === true;
}
function toIntFlag(value) {
  return value ? 1 : 0;
}
function mapApiToEditor() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    id: data.id,
    templateName: data.templateName || '',
    name: data.templateName || '',
    status: Number(data.status) || 0,
    active: Number(data.status) === 1,
    sceneType: Number(data.sceneType) || 1,
    isDefault: Number(data.isDefault) === 1,
    canEdit: data.canEdit !== false,
    canDelete: data.canDelete !== false,
    canSwitchDefault: data.canSwitchDefault !== false,
    showTitle: toBool(data.showTitle),
    titleText: data.titleName || '',
    titleName: data.titleName || '',
    showOrderSequence: toBool(data.showSerialNumber),
    showStoreName: toBool(data.showStoreName),
    showDeliveryTime: toBool(data.showDeliveryTime),
    showOrderTime: toBool(data.showOrderTime),
    showOrderNumber: toBool(data.showOrderNumber),
    showRemark: toBool(data.showRemark),
    showPhone: toBool(data.showPhone),
    phoneMask: toBool(data.phoneDesensitize),
    showAddress: toBool(data.showAddress),
    addressMask: toBool(data.addressDesensitize),
    showGoodsList: toBool(data.showProductList),
    showGoodsBarcode: toBool(data.showProductBarcode),
    showPrice: toBool(data.showPrice),
    showQuantity: toBool(data.showQuantity),
    showPackingFee: toBool(data.showPackingFee),
    showDeliveryFee: toBool(data.showDeliveryFee),
    showTotalQuantity: toBool(data.showTotalQuantity),
    totalQuantityName: data.totalQuantityName || '总数量',
    showTotalPrice: toBool(data.showTotalAmount),
    totalPriceLabel: data.totalAmountText || '合计',
    totalAmountText: data.totalAmountText || '合计',
    showTips: toBool(data.showBottomTips),
    tipsText: data.bottomTipsText || '',
    bottomTipsText: data.bottomTipsText || '',
    showPlatformName: true,
    platformName: '美团',
    storeName: '测试门店',
    updateTime: data.updateTime || ''
  };
}
function mapEditorToApi() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var payload = {
    templateName: (config.templateName || config.name || '').trim(),
    status: toIntFlag(config.active),
    sceneType: Number(config.sceneType) || 1,
    isDefault: toIntFlag(config.isDefault),
    showTitle: toIntFlag(config.showTitle),
    titleName: config.titleText || config.titleName || '',
    showSerialNumber: toIntFlag(config.showOrderSequence),
    showStoreName: toIntFlag(config.showStoreName),
    showDeliveryTime: toIntFlag(config.showDeliveryTime),
    showOrderTime: toIntFlag(config.showOrderTime),
    showOrderNumber: toIntFlag(config.showOrderNumber),
    showRemark: toIntFlag(config.showRemark),
    showPhone: toIntFlag(config.showPhone),
    phoneDesensitize: toIntFlag(config.phoneMask),
    showAddress: toIntFlag(config.showAddress),
    addressDesensitize: toIntFlag(config.addressMask),
    showProductList: toIntFlag(config.showGoodsList),
    showProductBarcode: toIntFlag(config.showGoodsBarcode),
    showPrice: toIntFlag(config.showPrice),
    showQuantity: toIntFlag(config.showQuantity),
    showPackingFee: toIntFlag(config.showPackingFee),
    showDeliveryFee: toIntFlag(config.showDeliveryFee),
    showTotalQuantity: toIntFlag(config.showTotalQuantity),
    totalQuantityName: config.totalQuantityName || '总数量',
    showTotalAmount: toIntFlag(config.showTotalPrice),
    totalAmountText: config.totalPriceLabel || config.totalAmountText || '合计',
    showBottomTips: toIntFlag(config.showTips),
    bottomTipsText: config.tipsText || config.bottomTipsText || ''
  };
  if (!options.isCreate && config.id != null && String(config.id) !== 'new') {
    payload.id = config.id;
  }
  return payload;
}
function createDefaultEditorConfig() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '新模板';
  return mapApiToEditor({
    templateName: name,
    status: 1,
    sceneType: 1,
    isDefault: 0,
    titleName: '外卖订单',
    totalAmountText: '合计',
    totalQuantityName: '总数量',
    bottomTipsText: '谢谢惠顾，欢迎下次光临！',
    showTitle: 1,
    showSerialNumber: 1,
    showStoreName: 1,
    showDeliveryTime: 1,
    showOrderTime: 1,
    showOrderNumber: 1,
    showRemark: 1,
    showPhone: 1,
    phoneDesensitize: 1,
    showAddress: 1,
    addressDesensitize: 1,
    showProductList: 1,
    showProductBarcode: 0,
    showPrice: 1,
    showQuantity: 1,
    showPackingFee: 1,
    showDeliveryFee: 1,
    showTotalQuantity: 1,
    showTotalAmount: 1,
    showBottomTips: 1,
    canEdit: true
  });
}
var mockReceiptData = exports.mockReceiptData = {
  sequence: '#23',
  platform: '美团',
  store: '测试门店',
  deliveryTime: '尽快送达',
  orderTime: '2026-06-24 17:30',
  orderNumber: 'MT202606241730001',
  remark: '少辣，餐具1份',
  phone: '13812345678',
  address: '仁寿县文林街道XX路88号2栋1单元902',
  goods: [{
    name: '宫保鸡丁盖饭',
    quantity: 1,
    price: 28
  }, {
    name: '酸梅汤',
    quantity: 2,
    price: 6
  }, {
    name: '小菜',
    quantity: 1,
    price: 3
  }],
  packingFee: 2,
  deliveryFee: 5
};
function createDefaultTemplate(id, name) {
  return {
    id: id,
    name: name,
    lastModified: new Date().toISOString(),
    active: true,
    sceneType: 1,
    status: 1,
    showTitle: true,
    titleText: '外卖订单',
    showSequenceNumber: true,
    showPlatformName: true,
    platformName: '美团',
    showStoreName: true,
    storeName: '测试门店',
    showDeliveryTime: true,
    showOrderTime: true,
    showOrderNumber: true,
    showRemark: true,
    showPhone: true,
    phoneMask: true,
    showAddress: true,
    addressMask: true,
    showGoodsList: true,
    showGoodsBarcode: false,
    showPrice: true,
    showQuantity: true,
    showPackingFee: true,
    showDeliveryFee: true,
    showTotalQuantity: true,
    showTotalPrice: true,
    totalQuantityName: '总数量',
    totalPriceLabel: '合计',
    showOrderSequence: true,
    showTips: true,
    tipsText: '谢谢惠顾，欢迎下次光临！',
    isDefault: false
  };
}
function getTemplates() {
  var raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    var initList = [createDefaultTemplate('1', '默认模板')];
    saveTemplates(initList);
    return initList;
  }
  try {
    var parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}
function saveTemplates(templates) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(templates || []));
}
function getTemplateById(id) {
  return getTemplates().find(function (item) {
    return String(item.id) === String(id);
  });
}
function saveTemplate(template) {
  var list = getTemplates();
  var index = list.findIndex(function (item) {
    return String(item.id) === String(template.id);
  });
  if (index > -1) {
    list.splice(index, 1, template);
  } else {
    list.push(template);
  }
  saveTemplates(list);
}
function deleteTemplate(id) {
  var list = getTemplates().filter(function (item) {
    return String(item.id) !== String(id);
  });
  saveTemplates(list);
}
function maskPhone() {
  var phone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var str = String(phone);
  if (str.length < 7) return str;
  return "".concat(str.slice(0, 3), "****").concat(str.slice(-4));
}
function maskAddress() {
  var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var str = String(address);
  if (!str) return '';
  if (str.length <= 8) return "".concat(str.slice(0, 4), "****");
  return "".concat(str.slice(0, 8), "****");
}